import { useEffect, useState } from "react";
import { CountdownProgress } from "../CountDownProgress/CountDownProgress";
import { UnlockChart } from "../UnlockChart/UnlockChart";
import { BACKEND_AI_AGENT_URL } from "../../../../../config";

interface UnlockEvent {
  dateTimestamp: number;
  percentOfCirculatingSupply: number;
  unlockAmount: number;
  unlockValue: number;
  rounds: {
    name: number;
    value: number;
  }[];
}

interface UnlockEventsData {
  lockedSupply: number;
  unlockedSupply: number;
  untrackedSupply: number;
  tokenSymbol: string;
  unlockEvents?: UnlockEvent[];
}

export const UnlockEvents = ({ projectId }: { projectId: string }) => {
  const [value, setValue] = useState<UnlockEventsData>({
    lockedSupply: 0,
    unlockedSupply: 0,
    untrackedSupply: 0,
    tokenSymbol: "",
    unlockEvents: [],
  });

  useEffect(() => {
    const fetchUnlocksData = async () => {
      try {
        const response = await fetch(
          `${BACKEND_AI_AGENT_URL}/unlock-events?projectId=${projectId}`,
        );

        if (!response.ok) {
          console.error("Failed to fetch unlock events");
          return;
        }

        const data: UnlockEventsData = await response.json();
        setValue(data);
      } catch (error) {
        console.error("Failed to fetch unlock events:", error);
      }
    };

    fetchUnlocksData();
  }, [projectId]);

  return (
    <div className="flex flex-col gap-4">
      <UnlockChart
        lockedSupply={value.lockedSupply}
        unlockedSupply={value.unlockedSupply}
        untrackedSupply={value.untrackedSupply}
        tokenSymbol={value.tokenSymbol}
      />
      <CountdownProgress
        unlockEvents={value?.unlockEvents}
        tokenSymbol={value.tokenSymbol}
      />
    </div>
  );
};
